
import React, { useState } from 'react'
import {
    AddContainer, Component4,
    Texts,
    Component6
} from './Styles';
import NumberInput from 'src/components/shared/Form/Number';
import SwitchComponent from 'src/components/shared/Form/Switch';
import { Formik, Form } from 'formik';

function ConsultingInfoStep({ data, innerRef, setDoctorProfileData }) {
    const [total, setTotal] = useState(0);
    const sanitizeNumber = (value) => {
        return value === '' || value === undefined || value === null ? 0 : Number(value);
    };

    const initialValues = {

        teleMedicine: data?.teleMedicine || 'No',
        inPersonAtClinic: data?.inPersonAtClinic || 'No',
        inPersonAtHome: data?.inPersonAtHome || 'No',
        emergencyAvailability: data?.emergencyAvailability || 'No',
        onePatientAverageTime: data?.onePatientAverageTime || 0,
        gapBetweenAppointments: data?.gapBetweenAppointments || 0,
        collectPatientsInfo: data?.collectPatientsInfo || 'No',
        newCaseConsultingFees: data?.newCaseConsultingFees || 0,
        oldCaseConsultingFees: data?.oldCaseConsultingFees || 0,
        consultationValidityDays: data?.consultationValidityDays || 0,
        noteForPatientsOnUnavailability: data?.noteForPatientsOnUnavailability || 'No',
        governmentYojana: data?.governmentYojana || 'No',
        treatmentAtClinic: data?.treatmentAtClinic || 'No',
        treatmentAtHome: data?.treatmentAtHome || 'No',
        publishProfileOnline: data?.publishProfileOnline || 'No',
        acceptPatientsOnline: data?.acceptPatientsOnline || 'No',
        insuranceAccepting: data?.insuranceAccepting || 'No',
    };


    const handleSubmit = (values) => {
        setDoctorProfileData(prev => ({
            ...prev,
            consulting: {
                ...values,
                newCaseConsultingFees: sanitizeNumber(values.newCaseConsultingFees),
                oldCaseConsultingFees: sanitizeNumber(values.oldCaseConsultingFees),
                consultationValidityDays: sanitizeNumber(values.consultationValidityDays),
                onePatientAverageTime: sanitizeNumber(values.onePatientAverageTime),
                gapBetweenAppointments: sanitizeNumber(values.gapBetweenAppointments),
            }
        }));
    };



    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                innerRef={innerRef}
            >

                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                    <Form>
                        <AddContainer>
                            <Component6 >
                                <Texts>Tele Medicines</Texts>
                                <SwitchComponent
                                    name="teleMedicine"
                                    checked={values.teleMedicine === 'Yes'}
                                    onChange={() => setFieldValue('teleMedicine', values.teleMedicine === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6 >
                                <Texts>In Person At Clinic</Texts>
                                <SwitchComponent
                                    name="inPersonAtClinic"
                                    checked={values.inPersonAtClinic === 'Yes'}
                                    onChange={() => setFieldValue('inPersonAtClinic', values.inPersonAtClinic === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6 >
                                <Texts>In Person At Home</Texts>
                                <SwitchComponent
                                    name="inPersonAtHome"
                                    checked={values.inPersonAtHome === 'Yes'}
                                    onChange={() => setFieldValue('inPersonAtHome', values.inPersonAtHome === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6 >
                                <Texts>Emergency Availability</Texts>
                                <SwitchComponent
                                    name="emergencyAvailability"
                                    checked={values.emergencyAvailability === 'Yes'}
                                    onChange={() => setFieldValue('emergencyAvailability', values.emergencyAvailability === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component4>
                                <Texts>One Patient AverageTime</Texts>
                                <NumberInput
                                    name="onePatientAverageTime"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.onePatientAverageTime}
                                    onChange={(val) => setFieldValue('onePatientAverageTime', val)}
                                />

                            </Component4>
                            <Component4>
                                <Texts>Gap Between Appointments</Texts>
                                <NumberInput
                                    name="gapBetweenAppointments"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.gapBetweenAppointments}
                                    onChange={(val) => setFieldValue('gapBetweenAppointments', val)}
                                />
                            </Component4>
                            <Component6 >
                                <Texts>Collect Patients Info</Texts>
                                <SwitchComponent
                                    name="collectPatientsInfo"
                                    checked={values.collectPatientsInfo === 'Yes'}
                                    onChange={() => setFieldValue('collectPatientsInfo', values.collectPatientsInfo === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component4>
                                <Texts>New Case ConsultingFees</Texts>
                                <NumberInput
                                    name="newCaseConsultingFees"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.newCaseConsultingFees}
                                    onChange={(val) => setFieldValue('newCaseConsultingFees', val)}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Old Case Consulting Fees</Texts>
                                <NumberInput
                                    name="oldCaseConsultingFees"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.oldCaseConsultingFees}
                                    onChange={(val) => setFieldValue('oldCaseConsultingFees', val)}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Consultation Validity (Days)</Texts>
                                <NumberInput
                                    name="consultationValidityDays"
                                    fullWidth
                                    width="auto" height="52px"
                                    value={values.consultationValidityDays}
                                    onChange={(val) => setFieldValue('consultationValidityDays', val)}
                                />
                            </Component4>
                            <Component6 >
                                <Texts>Note ForPatients On Unavailability</Texts>
                                <SwitchComponent
                                    name="noteForPatientsOnUnavailability"
                                    checked={values.noteForPatientsOnUnavailability === 'Yes'}
                                    onChange={() => setFieldValue('noteForPatientsOnUnavailability', values.noteForPatientsOnUnavailability === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6 >
                                <Texts>Insurance Accepting</Texts>
                                <SwitchComponent
                                    name="insuranceAccepting"
                                    checked={values.insuranceAccepting === 'Yes'}
                                    onChange={() => setFieldValue('insuranceAccepting', values.insuranceAccepting === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6 >
                                <Texts>Government Yojana</Texts>
                                <SwitchComponent
                                    name="governmentYojana"
                                    checked={values.governmentYojana === 'Yes'}
                                    onChange={() => setFieldValue('governmentYojana', values.governmentYojana === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6 >
                                <Texts>Treatment At Clinic</Texts>
                                <SwitchComponent

                                    name="treatmentAtClinic"
                                    checked={values.treatmentAtClinic === 'Yes'}
                                    onChange={() => setFieldValue('treatmentAtClinic', values.treatmentAtClinic === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6>
                                <Texts>Treatment At Home</Texts>
                                <SwitchComponent
                                    name="treatmentAtHome"
                                    checked={values.treatmentAtHome === 'Yes'}
                                    onChange={() => setFieldValue('treatmentAtHome', values.treatmentAtHome === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6 >
                                <Texts>Publish Profile Online</Texts>
                                <SwitchComponent
                                    name="publishProfileOnline"
                                    checked={values.publishProfileOnline === 'Yes'}
                                    onChange={() => setFieldValue('publishProfileOnline', values.publishProfileOnline === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                            <Component6>
                                <Texts>Accept Patients Online</Texts>
                                <SwitchComponent
                                    name="acceptPatientsOnline"
                                    checked={values.acceptPatientsOnline === 'Yes'}
                                    onChange={() => setFieldValue('acceptPatientsOnline', values.acceptPatientsOnline === 'Yes' ? 'No' : 'Yes')}
                                    sx={{
                                        margin: 0,
                                        padding: 0,
                                    }}
                                />
                            </Component6>
                        </AddContainer>
                    </Form>

                )}
            </Formik>
        </>
    )
}

export default ConsultingInfoStep;

